function generateMasonryGrid(columns, mode = "row", container) {
  const columnHeights = Array.from(Array(columns)).map(() => 0);
  const children = Array.from(container.children);
  for (let i = 0; i < columns; i++) {
    let div = document.createElement("div");
    div.classList.add("masonry-column");
    container.appendChild(div);
  }
  for (let i = 0; i < children.length; i++) {
    const teamMembersColumns =
      document.getElementsByClassName("masonry-column");
    let column = 0;
    if (mode === "row") {
      column = i % columns;
    } else {
      column = columnHeights.reduce(
        (targetIndex, columnHeight, columnIndex) => {
          const targetColumnHeight = columnHeights[targetIndex];
          if (targetColumnHeight > columnHeight) {
            return columnIndex;
          } else {
            return targetIndex;
          }
        },
        0
      );
      columnHeights[column] += children[i].offsetHeight;
    }
    teamMembersColumns[column].appendChild(children[i]);
  }
  container.style.display = "flex";
}
export default generateMasonryGrid;
